import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const lackOfConvergenceTestAPI = {
	getLackOfConvergenceTest: (caseId: string) => {
		return axios
			.get(`${apiUrl}/cases/${caseId}/lack-of-convergence-test`)
			.then((response) => response.data as LackOfConvergenceTestDTO[]);
	},
};

export default lackOfConvergenceTestAPI;
